import React, {useEffect} from "react";
import {Outlet} from "react-router-dom";
import s from "./mainLayout.module.scss";
import {authSelector, fetchMyUserInfo} from "../../redux/slices/authSlice";
import {useDispatch, useSelector} from "react-redux";
import {fetchInitialData} from "../../api/helpers/fetchGlobalData";
import {
    globalDataSelector,
    setExitPopup, setIsInstallsEndingInfoPopupActive, setNegativeBalancePopup,
} from "../../redux/slices/globalDataSlice";
import {logoutHandler} from "../../api/helpers/handlers";
import Footer from "../../components/Partials/Footer/Footer";
import NewTopUpBalancePopup from "../../components/UiKit/Popups/NewTopUpBalancePopup/NewTopUpBalancePopup";
import SvgSelector from "../../components/SvgSelector/SvgSelector";
import ConfirmPopup from "../../components/UiKit/Popups/ConfirmPopup/ConfirmPopup";
import Sidebar from "../../components/Partials/Sidebar/Sidebar";
import {useTranslation} from "react-i18next";
import NotificationsPopup from "../../components/UiKit/Popups/NotificationsPopup/NotificationsPopup";
import {TOKEN} from "../../storage/user";
import NewSidebar from "../../components/Partials/NewSidebar/NewSidebar";
import NegativeBalancePopup from "../../components/UiKit/Popups/NegativeBalancePopup/NegativeBalancePopup";
import {financeSelector} from "../../redux/slices/financeSlice";
import {getSubscriptionPaymentMethodStatus, subscriptionSelector} from "../../redux/slices/subscriptionSlice";
import {subscriptionLimits} from "../../pages/Authorized/SpecialAccess/Subscriptions/Subscriptions";
import {getInstallEndingIsNotifiedByInstallType, removeAllInstallsIsNotified} from "../../storage/installsLimits";

const MainLayout = () => {
    const dispatch = useDispatch();
    const {isPartner} = useSelector(authSelector);
    const {balance, balanceLoading} = useSelector(financeSelector);
    const {subscriptionsList, fetchSubscriptionsPending} = useSelector(subscriptionSelector);
    const {isCollapsedSidebar, exitPopup, isAdaptiveMenuActive, isInstallsEndingInfoPopupActive} =
        useSelector(globalDataSelector);

    const {t} = useTranslation();

    useEffect(() => {
        dispatch(fetchMyUserInfo());
        dispatch(getSubscriptionPaymentMethodStatus())
    }, [dispatch]);

    useEffect(() => {
        if (isPartner === false) {
            fetchInitialData(dispatch);
        }
    }, [dispatch, isPartner]);

    useEffect(() => {
        if (!balanceLoading && balance <= -50) {
            dispatch(setNegativeBalancePopup(true))
        }
    }, [balance, balanceLoading, dispatch]);

    const activeSubscription = subscriptionsList.find(item => item?.is_active && item?.active_by_time)

    useEffect(() => {


        if (activeSubscription && !fetchSubscriptionsPending) {

            subscriptionLimits.map(({defaultKey}) => {

                    const installType = defaultKey.split('_')[0]
                    const installsCount = activeSubscription?.[defaultKey]

                    if (typeof installsCount === 'number' && installsCount <= 100 && !getInstallEndingIsNotifiedByInstallType(installType) && !isInstallsEndingInfoPopupActive) {
                        dispatch(setIsInstallsEndingInfoPopupActive(true))
                    }
                }
            )
        }
        // else if (!activeSubscription && !fetchSubscriptionsPending) {
        //     removeAllInstallsIsNotified()
        // }
        // else {
        //     removeAllInstallsIsNotified()
        // }


    }, [dispatch, fetchSubscriptionsPending, activeSubscription])

    return (
        <div
            className={`${s.layoutContent} ${isAdaptiveMenuActive ? s.noScroll : ""}`}
        >
            <NewSidebar/>
            <div
                className={`${s.container} ${isCollapsedSidebar === "true" ? s.collapsed : ""}`}
            >
                <div className={s.pageContentWrapper}>
                    <ConfirmPopup
                        icon={<SvgSelector id="exit-popup-icon"/>}
                        active={exitPopup}
                        setActive={(value) => dispatch(setExitPopup(value))}
                        action={() => logoutHandler()}
                        confirmBtnText={t('logout')}
                        title={t('logout')}
                        description={t('logout_from_account')}
                        forcedClose={false}
                    />
                    <NegativeBalancePopup/>
                    <NewTopUpBalancePopup/>
                    <Outlet/>
                </div>
                <Footer/>
            </div>
        </div>
    );
};

export default MainLayout;
